import { useState, useRef, useCallback } from 'react';

/**
 * Hook de dictado por voz: usa el reconocimiento nativo del navegador (Web Speech API)
 * para convertir voz a texto, y devuelve ese texto crudo para que después se
 * pueda "pulir" con IA.
 */
export function useDictado() {
  const [grabando, setGrabando] = useState(false);
  const [soportado] = useState(
    typeof window !== 'undefined' &&
    ('SpeechRecognition' in window || 'webkitSpeechRecognition' in window)
  );
  const recognitionRef = useRef(null);
  const textoAcumuladoRef = useRef('');

  const iniciar = useCallback((onResultadoFinal) => {
    if (!soportado) return;
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'es-UY';
    recognition.continuous = true;
    recognition.interimResults = false;

    textoAcumuladoRef.current = '';

    recognition.onresult = (event) => {
      let textoNuevo = '';
      for (let i = event.resultIndex; i < event.results.length; i++) {
        textoNuevo += event.results[i][0].transcript;
      }
      textoAcumuladoRef.current += (textoAcumuladoRef.current ? ' ' : '') + textoNuevo;
    };

    recognition.onerror = () => {
      setGrabando(false);
    };

    recognition.onend = () => {
      setGrabando(false);
      if (onResultadoFinal) onResultadoFinal(textoAcumuladoRef.current.trim());
    };

    recognitionRef.current = recognition;
    recognition.start();
    setGrabando(true);
  }, [soportado]);

  const detener = useCallback(() => {
    if (recognitionRef.current) recognitionRef.current.stop();
  }, []);

  return { grabando, soportado, iniciar, detener };
}
